import { History, Trash2, Workflow } from "lucide-react";
import { Button } from "../../../ui/common/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "../../../ui/common/tooltip";
import { VERSION_HISTORY_COPY } from "../constants/versionHistory.constants";

interface VersionRowActionsProps {
  canActivate: boolean;
  /** false for the synthetic "unversioned" legacy bucket -- there is no version to open. */
  canGoToMapping: boolean;
  /** false for the synthetic "unversioned" legacy bucket -- there is no version to delete. */
  canDelete: boolean;
  isActivating: boolean;
  isDeleting: boolean;
  onGoToMapping: () => void;
  onRequestActivate: () => void;
  onRequestDelete: () => void;
}

export const VersionRowActions = ({
  canActivate,
  canGoToMapping,
  canDelete,
  isActivating,
  isDeleting,
  onGoToMapping,
  onRequestActivate,
  onRequestDelete
}: VersionRowActionsProps) => (
  <div className="tw-flex tw-items-center tw-justify-end tw-gap-1.5">
    {canGoToMapping ? (
      <Button
        type="button"
        size="sm"
        variant="outline"
        className="tw-h-8 tw-text-xs tw-gap-1.5"
        onClick={onGoToMapping}
      >
        <Workflow className="tw-h-3.5 tw-w-3.5" />
        {VERSION_HISTORY_COPY.goToMapping}
      </Button>
    ) : null}
    {canActivate ? (
      <Button
        type="button"
        size="sm"
        className="tw-h-8 tw-text-xs tw-gap-1.5"
        disabled={isActivating}
        onClick={onRequestActivate}
      >
        <History className="tw-h-3.5 tw-w-3.5" />
        {VERSION_HISTORY_COPY.activate}
      </Button>
    ) : null}
    {canDelete ? (
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            size="sm"
            variant="outline"
            className="tw-h-8 tw-text-xs tw-gap-1.5 tw-border-destructive/40 tw-text-destructive hover:tw-bg-destructive/10 hover:tw-text-destructive"
            disabled={isDeleting}
            onClick={onRequestDelete}
          >
            <Trash2 className="tw-h-3.5 tw-w-3.5" />
            {VERSION_HISTORY_COPY.delete}
          </Button>
        </TooltipTrigger>
        <TooltipContent>{VERSION_HISTORY_COPY.deleteTooltip}</TooltipContent>
      </Tooltip>
    ) : null}
  </div>
);
